<template>
  <DxDropDownButton class="header-dropdown-button"
                    icon="box"
                    :text="text"
                    :items="items"
                    :drop-down-options="{ width: 200 }"
                    @item-click="itemRoute"
  />
</template>

<script setup>
  import router from "@/router/index.js";
  import DxDropDownButton from 'devextreme-vue/drop-down-button'

  const props = defineProps(['text', 'items'])

  const itemRoute = (event) => {
    const item = event.itemData || event

    if (item && item.route)
      window.location.assign(router.resolve(item.route).href)
  }
</script>

<style lang="scss">
  .header-dropdown-button {
    margin: 0.25rem;

    .dx-button-has-icon.dx-button-has-text .dx-icon {
      margin: 0.25rem;
    }
  }
</style>
